import { Link as LinkRouter } from 'react-router-dom'
import { MenuItem } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import { useRouteMatch } from 'react-router-dom'
import useStyles from './styles'
import { withStyles } from '@material-ui/styles'

export const StyledMenuItem = withStyles(theme => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem)

const StyledMenuLink = React.forwardRef(
    (
        {
            to,
            children,
            text,
            onClick,
            mobile,
            reducePaddingLeft,
            id,
            external = false,
            className = '',
            target = '_self',
        },
        ref,
    ) => {
        const classes = useStyles()
        const match = useRouteMatch()
        let linkComponent

        if (!external) {
            linkComponent = (
                <LinkRouter
                    to={to}
                    className={clsx(className, classes.menuItem, {
                        active: match.url === to,
                        mobile: mobile,
                        [classes.reducePaddingLeft]: reducePaddingLeft,
                    })}
                    ref={ref}
                    onClick={e => {
                        if (onClick) {
                            e.preventDefault()
                            onClick()
                        }
                    }}
                    id={id}
                >
                    {text || children}
                </LinkRouter>
            )
        } else {
            linkComponent = (
                <a
                    href={to}
                    target={target}
                    className={clsx(className, classes.menuItem, {
                        active: match.url === to,
                        mobile: mobile,
                        [classes.reducePaddingLeft]: reducePaddingLeft,
                    })}
                    onClick={e => {
                        if (onClick) {
                            e.preventDefault()
                            onClick()
                        }
                    }}
                    id={id}
                >
                    {text || children}
                </a>
            )
        }
        if (mobile) {
            return <StyledMenuItem ref={ref}>{linkComponent}</StyledMenuItem>
        }
        return linkComponent
    },
)

StyledMenuLink.propTypes = {
    external: PropTypes.bool,
    className: PropTypes.string,
    target: PropTypes.string,
    to: PropTypes.string.isRequired,
    text: PropTypes.string,
    onClick: PropTypes.func,
    mobile: PropTypes.bool,
    reducePaddingLeft: PropTypes.bool,
}

export default React.memo(StyledMenuLink)
